import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useLocation } from "react-router-dom";
import logo from './logo.jpg';
import './Header.scss';

function Header() {
  const location = useLocation();

  const handleLogout = () => {
    localStorage.setItem("token", null)
  }

  return (    <Navbar expand="lg" className="bg-body-tertiary" sticky="top">
      <Container>
        {/* <Navbar.Brand href="/">logo</Navbar.Brand> */}
        <Navbar.Brand href="/"><img src={logo} alt="Logo" /></Navbar.Brand>
        <div className="d-flex align-items-center ms-auto phone-number" style={{marginRight: '10px'}}>
        <span className="me-2">📞 :</span>
        <a
          href="tel:0974352222"
          className="text-decoration-none fw-bold text-danger"
        >
          0974 352 222
        </a>
      </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            { location.pathname.includes("admin") && <Nav.Link href="/admin" onClick={handleLogout}>Đăng xuất</Nav.Link> }
            {/* <Nav.Link href="#link">Nhà đất cho thuê</Nav.Link> */}
            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
          
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
